<template>
  <div>
    <div class="settings_box">
      <h1>
        {{ getTranslations.home_profile_profile_edit_change_settings }}
      </h1>
      <h2>
        {{ getTranslations.home_profile_profile_edit_settings }}
      </h2>
      <div class="settings_row"
           style="cursor: pointer"
           @click.prevent="showAppropriateModal(0)">
        <p>
          {{ getTranslations.home_profile_profile_edit_change_username }}
        </p>
        <img src="static/images/profile/icon-arrow-r.svg">

      </div>
      <div class="settings_row"
           style="cursor: pointer"
           @click.prevent="showAppropriateModal(1)" v-if="!hideChangePassword">
        <p>
          {{ getTranslations.home_profile_profile_edit_change_pin }}
        </p>
        <img src="static/images/profile/icon-arrow-r.svg">
      </div>
      <span>
      <h2 >
        {{ getTranslations.home_profile_profile_edit_app_settings }}
      </h2>
      <div class="settings_row" >
        <p>
          {{ getTranslations.home_settings_language }}
        </p>
        <div class="lang_row">
          <a v-for="(value, key, index) in localesMappedWithIndices"
             @click.prevent="updateAndStoreNewLanguageAndLocale(key, value[0])"
             :class="settingsPageLocales[value[0]] && settingsPageLocales[value[0]].isActive ? 'selected' : ''"
             style="cursor: pointer"
             :key="index">
            {{ value[1] }}
          </a>
        </div>
      </div>
        <div class="settings_row" @click="updateSoundsStatus">
          <p>
            {{ getTranslations.home_settings_sound_music }}
          </p>
          <div class="switch__container">
            <input id="switch-shadow" class="switch switch--shadow" type="checkbox">
            <label for="switch-shadow"></label>
          </div>
        </div>
      </span>
      <h2 class="profile_settings_header">
        {{ getTranslations.home_profile_profile_edit_other_settings }}
      </h2>
      <div class="settings_row"
           @click.prevent="userChangeStatus()"
           style="cursor: pointer">
        <p>{{ userStatus }}</p>
        <img src="static/images/profile/icon-arrow-r.svg">
      </div>
    </div>
    <component :is="modalForSettings" @close="storeModalForSettings(null)"></component>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';
import ChangeUsername from '@/components/home/modals/ChangeUsername';
import SetPin from '@/components/home/modals/ChangeLoginPin';
import Unsubscribe from '@/components/home/modals/Unsubscribe';
import UnsubscribeSms from '@/components/home/modals/UnsubscribeSms';
import ResubscribeGame from '@/components/home/modals/ResubscribeGame';
import ResubscribeGameSms from '@/components/home/modals/ResubscribeGameSms';
import modals from '../../../common/modals';

export default {
  name: 'profile-edit',
  mixins: [RegistrationFlowMixin],
  data() {
    return {
      userStatus: '',
      editProfilePage: 'editProfile',
      soundChecked: true,
    };
  },
  created() {
    this.getUserStatusMethod();
    this.setProfilePath(false);
    this.$nextTick(() => {
      this.soundChecked = this.soundsOn;
    });
  },
  updated() {
    this.getUserStatusMethod();
  },
  beforeDestroy() {
    this.setProfilePath(true);
  },
  methods: {
    ...mapMutations('common', [
      'setProfilePath',
      'setSoundsOnOrOff',
      'storeModalForSettings',
    ]),
    ...mapMutations('i18n', [
      'setLocale',
      'updateActiveLocale',
    ]),
    ...mapActions('i18n', [
      'getLocaleAndTranslations',
      'updateUserLanguage',
    ]),
    ...mapActions('profile', [
      'storeAvailablePrizeTypes',
      'storeVisitorWinners',
    ]),
    isEligibleForPinChange() {
      return this.userDetails.hasPassword;
    },
    showAppropriateModal(actionCode) {
      let modal = '';
      switch (actionCode) {
      case 0: modal = ChangeUsername;
        break;
      case 1: modal = SetPin;
        break;
      default:
        break;
      }
      this.storeModalForSettings(modal);
    },
    userChangeStatus() {
      if (this.userDetails.subscribed) {
        if (this.subAndUnsubViaSMS) {
          if (this.reoptinAndOptoutConfig === 'OPTOUT_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
            this.storeModalForSettings(UnsubscribeSms);
          } else {
            this.storeModalForSettings(Unsubscribe);
          }
        } else {
          this.storeModalForSettings(Unsubscribe);
        }
      } else {
        // eslint-disable-next-line
        if (this.subAndUnsubViaSMS) {
          if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
            this.storeModalForSettings(ResubscribeGameSms);
          } else {
            this.storeModalForSettings(ResubscribeGame);
          }
        } else {
          this.storeModalForSettings(ResubscribeGame);
        }
      }
      modals.showHideModal(this);
    },
    getUserStatusMethod() {
      if (!this.userDetails.subscribed) {
        this.userStatus = this.getTranslations.home_settings_resubscribe;
      } else {
        this.userStatus = this.getTranslations.home_settings_unsubscribe;
      }
    },
    updateSoundsStatus() {
      this.soundChecked = !this.soundChecked;
      this.setSoundsOnOrOff(this.soundChecked);
      localStorage.setItem('soundsOn', this.soundChecked);
    },
    updateAndStoreNewLanguageAndLocale(locale, localeIndex) {
      this.updateActiveLocale(localeIndex);
      localStorage.setItem('locale', locale);
      this.setLocale({ currentLocale: locale });
      this.updateUserLanguage().then(() => {
        this.getLocaleAndTranslations().then(() => {
          this.storeAvailablePrizeTypes(this.getLocale);
          this.storeVisitorWinners(this.getLocale);
        });
      });
    },
  },
  computed: {
    ...mapState('common', [
      'hideLangSelection',
      'hideChangePassword',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
      'soundsOn',
      'userDetails',
      'modalForSettings',
    ]),
    ...mapState('i18n', [
      'settingsPageLocales',
      'localesMappedWithIndices',
    ]),
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/ProfileEdit.vue